<template>
  <div v-show="isShow.isPTShow" class="pageTwo">
    <Logo />
    <div class="moon"></div>
    <div class="zqtxt"></div>
    <div class="car"></div>

    <div class="drawbox">
      <div class="drawInner">
        <div class="zp"></div>
        <div class="jt"></div>
      </div>
    </div>
    <div class="yunbox yunpiao1">
      <div class="yun1"></div>
      <div class="yun2"></div>
      <div class="yun3"></div>
    </div>
    <div class="btnbox">
      <div class="btn cjbtn" @click="cjAction()">开始抽奖</div>
      <div class="btn mybtn" v-show="mygiftbtn">我的奖品</div>
    </div>
    <div class="hdgz" @click="pop('hdgztxtii')"></div>


    <div class="pop">
      <div class="popinner">
        <div class="popline">
          <div class="popii">
          <div class="poptop yunpiao2">
            <div class="y1"></div>
            <div class="y2"></div>
            <div class="y3"></div>
          </div>
          <div class="popcontent">
            <!--活动规则 BEGIN-->
            <div class="pinfo hdgztxt">
              <div class="btn" @click="hidepop">我知道了</div>
            </div>
            <!--活动规则 END-->

            <!--获奖信息 BEGIN-->
            <div class="pinfo zjtxt">
              <div class="jtitle">恭喜中奖!</div>
              <div class="jinfo">您获得：<span id="adtxt"></span>×1</div>
              <div class="jtip">请填写收货信息领取奖品
                <p>(如不填写即放弃本次领奖机会)</p>
              </div>
              <ul>
                <li><label for="name">姓名：</label><input type="text" id="name" /></li>
                <li><label for="tel">电话：</label><input type="text" id="tel" /></li>
                <li><label for="addr">地址：</label><input type="text" id="addr" /></li>
              </ul>
              <div class="btn" >确认提交</div>
            </div>
            <!--获奖信息 END-->

            <!--未中奖 BEGIN-->
            <div class="pinfo wzjtxt">
              <div class="jtitle">未中奖!</div>
              <div class="jinfo">奥迪英杰汇祝您中秋阖家欢乐！</div>
              <div class="btn" @click="hidepop">确认</div>
            </div>
            <!--未中奖 END-->

            <!--提交成功 BEGIN-->
            <div class="pinfo tjcgtxt">
              <div class="jtitle">提交成功</div>
              <div class="btn" @click="hidepop">确认</div>
            </div>
            <!--提交成功 END-->

            <!--提交失败 BEGIN-->
            <div class="pinfo tjsbtxt">
              <div class="jtitle">提交失败</div>
              <div class="btn" @click="hidepop">确认</div>
            </div>
            <!--提交失败 END-->

            <!--我的奖品 BEGIN-->
            <div class="pinfo wdjptxt">
              <div class="jtitle">我的奖品</div>
              <div class="jinfo"><span id="awardname"></span></div>
              <div class="btn" @click="hidepop">确认</div>
            </div>
            <!--我的奖品 END-->
          </div>
          <div class="popbottom yunpiao3">
            <div class="y4"></div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '../../components/logo/logo'
import $ from "jquery";

export default {
  name: 'PageTwo',
  props: {
    isShow: {
      type: Object
    },
    submainstagestate:{
      type:Boolean
    }
  },
  components: {
    Logo
  },
  data () {
    return {
      jpnr:new Array(),
      mygiftbtn:false,
      submitDataIng:false,
    }
  },
  methods: {
    _showNext () {
      this.$props.isShow.isPTShow = false
      this.$props.isShow.isPRShow = true
    },
   cartorun(){
     //汽车走
     $('.car').addClass('carrun')
     setTimeout(()=>{
       $('.car').hide()
       $('.moon').addClass('moonfang')
       $('.zqtxt').addClass('txtfang')
       setTimeout(()=>{
         $('.moon').hide();
         $('.drawbox').show();
         setTimeout(()=>{
           //转盘闪动
           $('.drawInner').addClass('shan')

           //按钮&规则
           $('.btnbox').show()
           $('.hdgz').show()

         },1200)
       },5000)
     },1000)
   },
   pop(n){
     //显示弹出层
     $('.pop').removeClass('hdgztxtii zjtxtii pinfo wzjtxtii tjcgtxtii tjsbtxtii wdjptxtii')
     $('.pop').addClass(n)
     $('.pop').show()
   },
   hidepop(){
     //隐藏弹出层
     $('.pop').hide()
   },
   cjAction(){
    alert('活动已经结束！')
    //  if(this.submitDataIng){
    //    return;
    //  }
     
    //  this.submitDataIng=true

    //  //抽奖
    //  $('.zp').removeClass('zpzhuan awardno3 awardno2 awardno1 award3 award2 award1')
    //  $('.zp').addClass('zpzhuan')
    
    // const _this=this
    
    // const URL = 'https://www.jiandoukeji.com/codes/2018/audizq/game.php/Home/Index/JDOU_game_award/'
    // const postData = {}
    // $.ajax({
    //   url: URL,
    //   type: 'POST',
    //   dataType: 'json',
    //   data: postData,
    //   success: function (res) {
    //     if(res.cjstate=='0'){
    //       //不能继续抽奖
    //       $('.zp').removeClass('zpzhuan awardno3 awardno2 awardno1 award3 award2 award1')
    //       alert('今日三次抽奖机会已用尽！')
    //     }else{
    //       if (res.status === 1) {
    //         let award=res.award
    //         //_this.showAward(award)
            

    //         setTimeout(()=>{
    //           _this.showAward(award)
    //         },3000)
    //       }
    //     }
    //   },
    //   error: function (err) {
    //     alert('请求出错！')
    //   }
    // })






   },

   showAward(n){
     let _this=this
     
     if(n==0){
       //未中奖状态
       let m=Math.floor(Math.random()*3+1)
       $('.zp').addClass('awardno'+m)

       //2秒后，弹出提示
       setTimeout(()=>{
         _this.pop('wzjtxtii')
         _this.submitDataIng=false
       },2500)
       
     }else{
       //中奖状态
      $('.zp').addClass('award'+n)
      document.getElementById('adtxt').innerHTML=_this.jpnr[n]
      //2秒后，弹出提示
       setTimeout(()=>{
         _this.pop('zjtxtii')
         _this.submitDataIng=false
       },2500)
     }

     
   },

  //  submitData(){
  //    //提交数据
  //   let name=document.getElementById('name').value
  //   let tel=document.getElementById('tel').value
  //   let addr=document.getElementById('addr').value

  //   if(name==''){
  //     alert('请填写姓名！')
  //     return;
  //   }

  //   if(tel==''){
  //     alert('请填写电话！')
  //     return;
  //   }

    
  //   var  re = /^1\d{10}$/
  //   if (!re.test(tel)){
  //     alert("电话号码错误！再核对一下吧！");
  //     return;
  //   }
    

  //   if(addr==''){
  //     alert('请填写地址！')
  //     return;
  //   }

  //   const URL = 'https://www.jiandoukeji.com/codes/2018/audizq/game.php/Home/Index/JDOU_game_record/'
  //   const postData = {
  //     'name':name,
  //     'addr':addr,
  //     'phone':tel
  //   }
  //   const _this = this
  //   $.ajax({
  //     url: URL,
  //     type: 'POST',
  //     dataType: 'json',
  //     data: postData,
  //     success: function (res) {
  //       _this.hidepop()

        
  //       //显示中奖结果
  //       if (res.status === 1) {
  //         _this.pop('tjcgtxtii')
  //       } else {
  //         _this.pop('tjsbtxtii')
  //       }

  //     },
  //     error: function (err) {
  //       alert('请求出错！')
  //     }
  //   })


  //  },
  //  mygift(){
  //    //我的礼品
  //    this.pop('wdjptxtii')


  //    const URL = 'https://www.jiandoukeji.com/codes/2018/audizq/game.php/Home/Index/JDOU_game_winner/'
  //   const postData = {}
  //   const _this = this
  //   $.ajax({
  //     url: URL,
  //     type: 'POST',
  //     dataType: 'json',
  //     data: postData,
  //     success: function (res) {
  //       if (res.status === 1) {
  //         let list=res.list
  //         let awardid=list[0]['award']
  //         let awardname=_this.jpnr[awardid]+'1个'
  //         console.log(awardid,awardname)
  //         //$('#awardname').val(awardname)
  //         document.getElementById('awardname').innerHTML=awardname
  //       }
  //     },
  //     error: function (err) {
  //       alert('请求出错！')
  //     }
  //   })
  //  },

  //  ismygift(){
  //    //是否显示【我的礼品】按钮

  //    const URL = 'https://www.jiandoukeji.com/codes/2018/audizq/game.php/Home/Index/JDOU_game_winner/'
  //   const postData = {}
  //   const _this = this
  //   $.ajax({
  //     url: URL,
  //     type: 'POST',
  //     dataType: 'json',
  //     data: postData,
  //     success: function (res) {
  //       if (res.status === 1) {
  //         let list=res.list
          
  //         if(list!=null){
  //           _this.mygiftbtn=true
  //         }
  //       }
  //     },
  //     error: function (err) {
  //       alert('请求出错！')
  //     }
  //   })
  //  },
  },
  mounted () {
    // this.ismygift()

    
    //this.cartorun() //开发时，使用
  
    

    this.jpnr[1]='奥迪TT车模'
    this.jpnr[2]='奥迪定制U盘'
    this.jpnr[3]='奥迪小熊钥匙链'

     window.alert = function (name) {
      const iframe = document.createElement('IFRAME');
      iframe.style.display = 'none';
      iframe.setAttribute('src', 'data:text/plain,');
      document.documentElement.appendChild(iframe);
      window.frames[0].window.alert(name);
      iframe.parentNode.removeChild(iframe);
    };
  },
  watch: {
    submainstagestate(){
      this.cartorun()
    }
  }
}
</script>

<style lang="less" scoped>
.pageTwo {
  width: 100%;
  height: 100%;
  background-image:url(./ltr_bg.png);
  background-size:100% auto;
  background-repeat: no-repeat;
  background-position: 0 0;
  background-color: #11162a;

  .car{
    background-image:url(./kv_car.png);
    width: (17.5625/2rem) /* 281/16 */;
    height: (13.1875/2rem) /* 211/16 */;
    background-size:100% 100%;
    position: absolute;
    margin-left: (-17.5625/4rem);
    left:0;
    top: 75.5%;
    transform: rotate(-8deg);
  }
  .carrun{
    animation: 1s carrun linear;
  }

  .btn{
    background-image:url(./btn.png);
    background-size:100% 100%;
    width: (15/2rem) /* 240/16 */;
    height: (3.9375/2rem) /* 63/16 */;
    text-align: center;
    line-height:(3.75/2rem) /* 60/16 */;
    color: #fff;
    font-weight: 700;
    font-size: 14px;
  }

  .moon{
    background-image:url(./kv_moon.png);
    width: (46.875rem/2) /* 750/16 */;
    height: (46.875rem/2) /* 750/16 */;
    background-size:100% 100%;
    position: absolute;
    margin-left: (-46.875/4rem) /* 750/16 */;
    left:50%;
    top: 0;
    z-index: 3;
    transform-origin: 50% 50%;
  }

  .zqtxt{
    background-image:url(./txt.png);
    width: (15.75/2rem) /* 252/16 */;
    height: (5.625/2rem) /* 90/16 */;
    background-size:100% 100%;
    position: absolute;
    margin-left: (-15.75/4rem) /* 252/16 */;
    left:50%;
    top: (42.5/2rem) /* 680/16 */;
    z-index: 3;
    transform-origin: 50% 50%;
    opacity: 0;
  }

  .drawbox{
    background-image:url(./ltr_round.png);
    width: (43.4375/2rem) /* 695/16 */;
    height: (45.3125/2rem) /* 725/16 */;
    background-size:100% 100%;
    position: absolute;
    margin-left: (-43.4375/4rem) /* 695/16 */;
    left:50%;
    top: 20vh;
    display: none;
    z-index: 2;
  }

  .drawInner{
    position: relative;
    width: 100%;
    height: 100%;

    background-image:url(./guang.png);
    background-size:100% 100%;
  }

  .zp{
    background-image:url(./ltr_round-inner.png);
    width: (37.25/2rem) /* 596/16 */;
    height: (37.25/2rem) /* 596/16 */;
    background-size:100% 100%;
    position: absolute;
    left:50%;
    margin-left: (-37.25/4rem) /* 596/16 */;
    top: 24px;
  }

  .jt{
    background-image:url(./ltr_pointer.png);
    width: (7.8125/2rem) /* 125/16 */;
    height: (10.875/2rem) /* 174/16 */;
    background-size:100% 100%;
    position: absolute;
    margin-left:(-7.8125/4rem) /* 125/16 */;
    left:50%;
    top: 118px;
  }

  .moonfang{
    animation: 5s moonfang linear;
  }

  .txtfang{
    animation: 1s txtfang linear;
  }

  @keyframes txtfang {
    0%{
      opacity: 0;
    }
    20%{
      opacity: 1;
      //transform: scale(1)
    }
    80%{
      opacity: 1;
      //transform: scale(1)
    }
    100%{
      opacity: 0;
      //transform: scale(2)
    }
  }

  .shan{
    animation: 1s shan linear infinite;
  }

  .yunbox{
    background-image:url(./ltr_cloud.png);
    width: (42.5/2rem) /* 680/16 */;
    height: (13.9375/2rem) /* 223/16 */;
    background-size:100% 100%;
    position: absolute;
    margin-left:(-42.5/4rem) /* 680/16 */;
    left:50%;
    top: 5vh;
  }
  .yunpiao1{
    animation: 3s yunpiao1 infinite;
  }

  .btnbox{
    position: absolute;
    bottom: 10vh;
    text-align: center;
    width: 100%;
    display: none;
    z-index: 5;
    
    div{
      display: inline-block;
      margin: 0 1.25rem /* 20/16 */;
    }
  }

  .hdgz{
    background-image:url(./ltr_btn-detailes.png);
    width: (9.75/2rem) /* 156/16 */;
    height: (4.625/2rem) /* 74/16 */;
    background-size:100% 100%;
    position: absolute;
    margin-left:(-9.75/4rem) /* 156/16 */;
    left:50%;
    bottom: 3vh;
    display: none;
  }

  //弹出层
  .pop{
    display: none;
    position: absolute;
    z-index: 9;
    background-color: rgba(0,0,0,0.8);
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  .popinner{
    width: 90%;
    position: absolute;
    left: 5%;
    top: 50%;
    background: rgba(17,22,42,0.8);
    border-radius: 5px;
  }

  .popline{
    border: 1px solid #f4f4e5;
    margin: 15px;
    position: relative;
    border-radius: 5px;
    .btn{
      left:50%;
      margin-left:(-7.5/2rem) /* 240/16 */;
      position: absolute;
      bottom: 2.1875rem /* 35/16 */;
    }
  }

  .popii{
    width: 100%;
    height: 100%;
  }

  .poptop{
    background-image:url(./poptop.png);
    background-size:100% 100%;
    width: (50.625/2rem) /* 810/16 */;
    height: (19.0625/2rem) /* 305/16 */;
    position: absolute;
    top: -15.625/2rem /* 250/16 */;
    left: 50%;
    margin-left: -50.625/4rem /* 810/16 */;
  }

  .popbottom{
    background-image:url(./popbottom.png);
    background-size:100% 100%;
    width: (50.625/2rem) /* 810/16 */;
    height: (9.25/2rem) /* 148/16 */;
    position: absolute;
    bottom:(-7.5/2rem) /* 120/16 */;
    left: 50%;
    margin-left: (-50.625/4rem) /* 810/16 */;
  }

  .jtitle{
    color: #eee5ab;
    font-size: (3.125/2rem) /* 50/16 */;
    text-align: center;
    padding: 1.875rem /* 30/16 */ 0;
  }

  .jinfo{
    color: #fff;
    font-size: (2.25/2rem) /* 36/16 */;
    text-align: center;
  }

  .jtip{ 
    border-top:1px dotted #eee5ab;
    margin-top: 1.875rem /* 30/16 */;

    color: #f4f4e5;
    font-size: (1.625/2rem) /* 26/16 */;
    padding-top: 20px;
    text-align: center;
    padding-bottom: 20px;
    line-height: 1.5em;
  }

  .pinfo{
    display: none;
  }

  .yunpiao2{
    animation: 3s yunpiao2 infinite;
  }

  .yunpiao3{
    animation: 4s yunpiao3 infinite;
  }

  //活动规则
  .hdgztxtii{
    .popinner{
      margin-top: (-56.75/4rem);
    }
    .popline{
      border: 0;
      margin-left:8px;
    }
    .hdgztxt{
      background-image:url(./ltr_details.png);
      background-size:100% 100%;
      width: (40.125/2rem) /* 642/16 */;
      height: (56.75/2rem) /* 908/16 */;
      display: block;
      position: relative;
    }
    .btn{
      bottom: 3.4375rem /* 55/16 */;
    }
  }

  //恭喜中奖
  .zjtxtii{
    .popinner{
      margin-top: (-56.25/4rem) /* 850/16 */;
    }
    .zjtxt{
      height:(56.25/2rem) /* 900/16 */;
      display: block;
    }

    ul{
      width: (35.3125/2rem) /* 565/16 */;
      margin: 0 auto;
    }
    li{
      height: 3.75rem /* 60/16 */;
      color: #fff;
      font-size: (1.875/2rem) /* 30/16 */;
    }
    input{
      width:(26.25/2rem) /* 420/16 */;
      height: (3.9375/2rem) /* 63/16 */;
      line-height: (3.9375/2rem) /* 63/16 */;
      padding: 0 .625rem /* 10/16 */;
      color: #fff;
      background-color: #071c3b;
      border-radius: 3px;
    }
  }

  //未中奖
  .wzjtxtii{
    .popinner{
      margin-top: (-25/4rem) /* 400/16 */;
    }
    .wzjtxt{
      height: (25/2rem) /* 400/16 */;
      display: block;
    }
  }

  //提交成功
  .tjcgtxtii{
    .popinner{
      margin-top: (-25/4rem) /* 400/16 */;
    }
    .jtitle{
      padding-top: 3.75rem /* 60/16 */;
    }
    .tjcgtxt{
      height: (25/2rem) /* 400/16 */;
      display: block;
    }
  }

  //提交失败
  .tjsbtxtii{
    .popinner{
      margin-top: (-25/4rem) /* 400/16 */;
    }
    .jtitle{
      padding-top: 3.75rem /* 60/16 */;
      color:#a8a7a1;
    }
    .tjsbtxt{
      height: (25/2rem) /* 400/16 */;
      display: block;
    }
  }

  //我的奖品
  .wdjptxtii{
    .popinner{
      margin-top: (-25/4rem) /* 400/16 */;
    }
    .wdjptxt{
      height: (25/2rem) /* 400/16 */;
      display: block;
    }
  }

  .zpzhuan{
    animation: 0.5s zpzhuan infinite linear;
  }

  .award1{
    transform: rotate(0);
    animation: 1s;
    animation: 2s award1zhuan ease-out;
  }

  @keyframes award1zhuan {
    0%{
      transform: rotate(0deg);
    }
    100%{
      transform: rotate(360deg);
    }
  }

  

  .award2{
    transform: rotate(240deg);
    animation: 2s award2zhuan ease-out;
  }

  @keyframes award2zhuan {
    0%{
      transform: rotate(0deg);
    }
    100%{
      transform: rotate(240deg);
    }
  }

  .award3{
    transform: rotate(120deg);
    animation: 2s award3zhuan ease-out;
  }
  @keyframes award3zhuan {
    0%{
      transform: rotate(0deg);
    }
    100%{
      transform: rotate(120deg);
    }
  }

  .awardno1{
    transform: rotate(60deg);
    animation: 2s awardno1zhuan ease-out;
  }
  @keyframes awardno1zhuan {
    0%{
      transform: rotate(0deg);
    }
    100%{
      transform: rotate(60deg);
    }
  }

  .awardno2{
    transform: rotate(180deg);
    animation: 2s awardno2zhuan ease-out;
  }
  @keyframes awardno2zhuan {
    0%{
      transform: rotate(0deg);
    }
    100%{
      transform: rotate(180deg);
    }
  }

  .awardno3{
    transform: rotate(300deg);
    animation: 2s awardno3zhuan ease-out;
  }
  @keyframes awardno3zhuan {
    0%{
      transform: rotate(0deg);
    }
    100%{
      transform: rotate(300deg);
    }
  }

}

@keyframes carrun {
  0%{
    left:0;
    top: 75.5%;
    transform: rotate(-8deg);
  }
  50%{
    left:50%;
    top: 74.5%;
    transform: rotate(-3deg);
  }
  100%{
    left:120%;
    top: 75.8%;
    transform: rotate(0deg);
  }
}

@keyframes moonfang {
  0%{
    transform: scale(1)
  }
  50%{
    transform: scale(1)
  }
  80%{
    top: 18%;
    transform: scale(1.6);
    opacity: 1;
  }
  100%{
    top: 18%;
    transform: scale(1.6);
    opacity: 0;
  }
}

@keyframes shan {
  0%{
    background-image:url(./guang1.png);
  }
  50%{
    background-image:url(./guang2.png);
  }
  100%{
    background-image:url(./guang1.png);
  }
}

@keyframes yunpiao1 {
  0%{
    transform: translateY(0px);
  }
  50%{
    transform: translateY(10px);
  }
  100%{
    transform: translateY(0px);
  }
}

@keyframes yunpiao2 {
  0%{
    transform: translateY(0px);
  }
  50%{
    transform: translateY(5px);
  }
  100%{
    transform: translateY(0px);
  }
}

@keyframes yunpiao3 {
  0%{
    transform: translateY(0px);
  }
  50%{
    transform: translateY(-5px);
  }
  100%{
    transform: translateY(0px);
  }
}

@keyframes zpzhuan {
  0%{
    transform: rotate(0);
  }
  100%{
    transform: rotate(360deg);
  }
}
</style>
